// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GrowthTracking.module.css */

.GrowthTrackingTab_dashboardContainer__e\\+-0S {
  background-color: #f1f2fb;
  min-height: auto;
  font-family: inherit;
   margin-bottom: 0;
  padding-bottom: 0;
}

.GrowthTrackingTab_sectionTitle__qHJYC {
  color: #364e69;
  font-weight: 600;
  font-size: 1.25rem;
  font-family: inherit;
}

.GrowthTrackingTab_kpiCard__mkAJV {
  background: white;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  height: 140px; /* Fixed height: reduce this to shrink the card */
  padding: 0.75rem; /* Less padding = more compact */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start; /* or center if you want centered content */
}

.GrowthTrackingTab_kpiIcon__u4id0 {
  color: #358696;
  width: 24px;
  height: 24px;
}

.GrowthTrackingTab_kpiValue__HbJkt {
  font-size: 1.5rem;
  font-weight: 700;
  color: #364e69;
  font-family: inherit;
}

.GrowthTrackingTab_kpiLabel__jXxzu {
  font-size: 0.875rem;
  color: #6b7280;
  font-family: inherit;
}

.GrowthTrackingTab_up__3NtjZ::after {
  content: "↗";
  color: #10b981;
  margin-left: 4px;
}

.GrowthTrackingTab_down__4xq4Q::after {
  content: "↘";
  color: #ef4444;
  margin-left: 4px;
}

.GrowthTrackingTab_vehicleSelection__4xXqp {
  background: white;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.GrowthTrackingTab_vehicleIcon__ySZBD {
  color: #358696;
  width: 20px;
  height: 20px;
}

.GrowthTrackingTab_btnToggle__eLpV5 {
  background-color: #358696;
  border: none;
  border-radius: 20px;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 8px 16px;
  margin: 0 2px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-family: inherit;
}

.GrowthTrackingTab_btnToggle__eLpV5.GrowthTrackingTab_active__rgfMC {
  background-color: #364e69;
}

.GrowthTrackingTab_btnToggle__eLpV5:hover {
  background-color: #6b8db5;
}

.GrowthTrackingTab_paramCard__VFkUN {
  background: white;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.GrowthTrackingTab_paramIcon__PuwvE {
  color: #358696;
  width: 20px;
  height: 20px;
}

.GrowthTrackingTab_paramTitle__Dm3Kn {
  font-size: 0.875rem;
  color: #364e69;
  font-weight: 500;
  font-family: inherit;
}

.GrowthTrackingTab_paramValue__HUtoL {
  font-size: 1.125rem;
  font-weight: 600;
  color: #364e69;
  font-family: inherit;
}

.GrowthTrackingTab_paramSubtitle__fs422 {
  font-size: 0.75rem;
  color: #9ca3af;
  font-family: inherit;
}


.GrowthTrackingTab_viewGraphBtn__4DUzG {
  color: #358696;
  text-decoration: none;
  font-size: 0.75rem;
  font-weight: 500;
  font-family: inherit;
}

.GrowthTrackingTab_viewGraphBtn__4DUzG:hover {
  color: #6b8db5;
  text-decoration: underline;
}

.GrowthTrackingTab_chartContainer__c08gE {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  height: 300px;
}

.GrowthTrackingTab_downloadBtn__a7IIg {
  color: #358696;
  text-decoration: none;
  font-size: 0.875rem;
  font-family: inherit;
  border: none;
  background: transparent;
}

.GrowthTrackingTab_carbonInfo__EdLK3 {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: inherit;
}

.GrowthTrackingTab_selectCustom__U6Xoy {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #364e69;
  background-color: white;
  padding: 8px 12px;
  font-family: inherit;
  width: 100%;
}

.GrowthTrackingTab_chartSvg__0PaSX {
  /* Additional chart-specific styles if needed */
}
.GrowthTrackingTab_download-btn-wrapper__dDwc3 {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px 0;
  align-items: right;
  position: absolute;
  
  margin-right: 20px;
}
.GrowthTrackingTab_download-btn-container__6p5Z-{
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/GrowthTrackingTab_ace/GrowthTrackingTab.module.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;GACnB,gBAAgB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;;EAEzC,aAAa,EAAE,iDAAiD;EAChE,gBAAgB,EAAE,gCAAgC;EAClD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAE,2CAA2C;AACtE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;;EAElB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb","sourcesContent":["/* GrowthTracking.module.css */\n\n.dashboardContainer {\n  background-color: #f1f2fb;\n  min-height: auto;\n  font-family: inherit;\n   margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.sectionTitle {\n  color: #364e69;\n  font-weight: 600;\n  font-size: 1.25rem;\n  font-family: inherit;\n}\n\n.kpiCard {\n  background: white;\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n\n  height: 140px; /* Fixed height: reduce this to shrink the card */\n  padding: 0.75rem; /* Less padding = more compact */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start; /* or center if you want centered content */\n}\n\n.kpiIcon {\n  color: #358696;\n  width: 24px;\n  height: 24px;\n}\n\n.kpiValue {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #364e69;\n  font-family: inherit;\n}\n\n.kpiLabel {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-family: inherit;\n}\n\n.up::after {\n  content: \"↗\";\n  color: #10b981;\n  margin-left: 4px;\n}\n\n.down::after {\n  content: \"↘\";\n  color: #ef4444;\n  margin-left: 4px;\n}\n\n.vehicleSelection {\n  background: white;\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.vehicleIcon {\n  color: #358696;\n  width: 20px;\n  height: 20px;\n}\n\n.btnToggle {\n  background-color: #358696;\n  border: none;\n  border-radius: 20px;\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 8px 16px;\n  margin: 0 2px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-family: inherit;\n}\n\n.btnToggle.active {\n  background-color: #364e69;\n}\n\n.btnToggle:hover {\n  background-color: #6b8db5;\n}\n\n.paramCard {\n  background: white;\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.paramIcon {\n  color: #358696;\n  width: 20px;\n  height: 20px;\n}\n\n.paramTitle {\n  font-size: 0.875rem;\n  color: #364e69;\n  font-weight: 500;\n  font-family: inherit;\n}\n\n.paramValue {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #364e69;\n  font-family: inherit;\n}\n\n.paramSubtitle {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  font-family: inherit;\n}\n\n\n.viewGraphBtn {\n  color: #358696;\n  text-decoration: none;\n  font-size: 0.75rem;\n  font-weight: 500;\n  font-family: inherit;\n}\n\n.viewGraphBtn:hover {\n  color: #6b8db5;\n  text-decoration: underline;\n}\n\n.chartContainer {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  height: 300px;\n}\n\n.downloadBtn {\n  color: #358696;\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: none;\n  background: transparent;\n}\n\n.carbonInfo {\n  font-size: 0.75rem;\n  color: #6b7280;\n  font-family: inherit;\n}\n\n.selectCustom {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  color: #364e69;\n  background-color: white;\n  padding: 8px 12px;\n  font-family: inherit;\n  width: 100%;\n}\n\n.chartSvg {\n  /* Additional chart-specific styles if needed */\n}\n.download-btn-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 20px 0;\n  align-items: right;\n  position: absolute;\n  \n  margin-right: 20px;\n}\n.download-btn-container{\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardContainer": `GrowthTrackingTab_dashboardContainer__e+-0S`,
	"sectionTitle": `GrowthTrackingTab_sectionTitle__qHJYC`,
	"kpiCard": `GrowthTrackingTab_kpiCard__mkAJV`,
	"kpiIcon": `GrowthTrackingTab_kpiIcon__u4id0`,
	"kpiValue": `GrowthTrackingTab_kpiValue__HbJkt`,
	"kpiLabel": `GrowthTrackingTab_kpiLabel__jXxzu`,
	"up": `GrowthTrackingTab_up__3NtjZ`,
	"down": `GrowthTrackingTab_down__4xq4Q`,
	"vehicleSelection": `GrowthTrackingTab_vehicleSelection__4xXqp`,
	"vehicleIcon": `GrowthTrackingTab_vehicleIcon__ySZBD`,
	"btnToggle": `GrowthTrackingTab_btnToggle__eLpV5`,
	"active": `GrowthTrackingTab_active__rgfMC`,
	"paramCard": `GrowthTrackingTab_paramCard__VFkUN`,
	"paramIcon": `GrowthTrackingTab_paramIcon__PuwvE`,
	"paramTitle": `GrowthTrackingTab_paramTitle__Dm3Kn`,
	"paramValue": `GrowthTrackingTab_paramValue__HUtoL`,
	"paramSubtitle": `GrowthTrackingTab_paramSubtitle__fs422`,
	"viewGraphBtn": `GrowthTrackingTab_viewGraphBtn__4DUzG`,
	"chartContainer": `GrowthTrackingTab_chartContainer__c08gE`,
	"downloadBtn": `GrowthTrackingTab_downloadBtn__a7IIg`,
	"carbonInfo": `GrowthTrackingTab_carbonInfo__EdLK3`,
	"selectCustom": `GrowthTrackingTab_selectCustom__U6Xoy`,
	"chartSvg": `GrowthTrackingTab_chartSvg__0PaSX`,
	"download-btn-wrapper": `GrowthTrackingTab_download-btn-wrapper__dDwc3`,
	"download-btn-container": `GrowthTrackingTab_download-btn-container__6p5Z-`
};
export default ___CSS_LOADER_EXPORT___;
